import { css } from '@emotion/react'
import { ThemedColors, Typography } from '@opallabs/gem'

// The design's label style, the same one `InputLabel` wears.
export const inputLabel = css({
  ...Typography.H50,
  color: `var(${ThemedColors.TextPrimary})`,
  // A block, so the label's box is its line and the gap under it is exact.
  display: 'block',
})
